var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2h3.333v3.333H2V2ZM6.333 2h3.334v3.333H6.333V2ZM14 2h-3.333v3.333H14V2ZM2 6.333h3.333v3.334H2V6.333ZM9.667 6.333H6.333v3.334h3.334V6.333ZM10.667 6.333H14v3.334h-3.333V6.333ZM5.333 10.667H2V14h3.333v-3.333ZM6.333 10.667h3.334V14H6.333v-3.333ZM14 10.667h-3.333V14H14v-3.333Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export default ForwardRef;